import PhotoSwipeLightbox from 'photoswipe/lightbox';

class ProductGalleryZoom extends HTMLElement {
  #lightbox = null;
  #isDesktop = window.matchMedia('(min-width: 992px)').matches;

  connectedCallback() {
    if (!this.#isDesktop) {
      this.querySelectorAll('a[data-pswp-width]').forEach((link) => {
        link.addEventListener('click', (e) => e.preventDefault());
      });
      return;
    }

    this.#lightbox = new PhotoSwipeLightbox({
      gallery: this,
      children: 'a[data-pswp-width]',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 1,
      zoom: false,
      arrowPrevSVG: '<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.5 12.7071L0.5 6.70711L6.5 0.707108" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      arrowNextSVG: '<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.5 0.707108L7.5 6.70711L1.5 12.7071" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"/></svg>',
      closeSVG: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><line x1="5.39757" y1="5.23526" x2="18.8326" y2="18.6703" stroke="#0B0A09" stroke-linecap="round"/><line x1="4.92856" y1="18.3643" x2="18.3636" y2="4.92929" stroke="#0B0A09" stroke-linecap="round"/></svg>',
    });

    this.#lightbox.init();
  }

  disconnectedCallback() {
    this.#lightbox?.destroy();
    this.#lightbox = null;
  }
}

if (!customElements.get('product-gallery-zoom')) {
  customElements.define('product-gallery-zoom', ProductGalleryZoom);
}
